/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import BatchUpdateAbstract from 'cio/app-models/action-abstracts/batch-update';
import CreateOrUpdatePersonAbstract from 'cio/app-models/action-abstracts/create-or-update-person';
import { isBlank } from '@ember/utils';
import { DataActionConditionType } from 'cio/utils/campaigns/data-action';
import { shouldShowRemoveAttribute } from 'cio/utils/actions/create-or-update-person';
import { createActionAbstract } from 'cio/utils/visual-workflow-builder/action-abstracts';
import CampaignModel from 'cio/models/campaign';

interface WorkflowActionAttributeUpdateDescriptionArgs {
  action: ActionModel;
  campaign: CampaignModel;
}

export default class WorkflowActionAttributeUpdateDescription extends Component<WorkflowActionAttributeUpdateDescriptionArgs> {
  get actionAbstract(): CreateOrUpdatePersonAbstract | BatchUpdateAbstract {
    return createActionAbstract(this.args.action);
  }

  get rows() {
    let { action } = this.args;
    let { actionAbstract } = this;

    let rows: { name: string; type: DataActionConditionType; value: string }[] = [];

    if (action.isCreateOrUpdatePersonAttributeAction || action.isBatchUpdateAction) {
      rows = actionAbstract.bodyRows.rows.map((r) => ({
        name: r.name,
        type: r.type,
        value: r.value,
      }));
    } else {
      if (!action.hasContent) {
        rows = [];
      } else {
        rows = [
          {
            name: action.attributeName,
            type: isBlank(action.attributeName)
              ? DataActionConditionType.RemoveAttribute
              : DataActionConditionType.Liquid,
            value: action.attributeValue,
          },
        ];
      }
    }

    return rows.map((r) => ({ ...r, showRemove: shouldShowRemoveAttribute(r) }));
  }
}
